module.exports = __webpack_public_path__ + "static/media/shield-alt.9d407496.svg";